/* eslint-disable */

import Router from "vue-router";
import Vue from "vue";

function load(component) {
    return () => import(`@/pages/${component}.vue`);
}
Vue.use(Router);
let router = new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "Home",
            component: load("home/Home"),
        },
        {
            path: "/company",
            name: "Company",
            component: load("company/Company"),
        },
        {
            path: "/careers",
            name: "Careers",
            component: load("careers/Careers"),
        },
        {
            path: "/contact",
            name: "Contact",
            component: load("contact/Contact"),
        },
        {
            path: "/disclaimer",
            name: "Disclaimer",
            component: load("disclaimer/Disclaimer"),
        },
        {
            path: "/privacy-policy",
            name: "Privacy",
            component: load("privacy/Privacy"),
        },
        {
            path: "/services",
            name: "Services",
            component: load("services/Services"),
        },
        {
            path: "/sitemap",
            name: "Sitemap",
            component: load("sitemap/Sitemap"),
        },
        {
            path: "/testimonials",
            name: "Testimoniials",
            component: load("testimonials/Testimonials")
        },{
            path: "/wpa",
            name: "WPA",
            component: load("wpa/WPA")
        }
    ],
      scrollBehavior() {
        return {x: 0, y: 0}
    }
})


export default router;
